exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".back-btn[data-v-112b9f41] {\n  display: flex;\n  justify-content: space-between;\n}\n@media (max-width: 768px) {\n.back-btn[data-v-112b9f41] {\n    flex-direction: column;\n}\n.back-btn button[data-v-112b9f41] {\n    width: 100%;\n}\n}\n.buttons-right[data-v-112b9f41] {\n  display: flex;\n  justify-content: flex-end;\n}\n@media (max-width: 768px) {\n.buttons-right[data-v-112b9f41] {\n    flex-direction: column;\n}\n.buttons-right button[data-v-112b9f41] {\n    width: 100%;\n}\n}\n#updateProfileModalCustom[data-v-112b9f41] {\n  justify-content: center;\n}\n", ""]);

// exports
